import {CmsDynamicArray} from '../components/elements/cms/CmsComponentMapper';
import {WithCaptionProps} from '../components/wraps';

export type ReactCommonBackgroundVideoOptions =
    | 'htmlVideo'
    | 'youtubeVideo'
    | 'tencentVideo'
    | 'twitchVideo'
    | 'embedVideo'
    | 'image';

export interface ReactCommonBackgroundVideoProps {
    type?: ReactCommonBackgroundVideoOptions;
    contentId?: string;
    alt?: string;
    content: string[];
    caption?: string;
    opacity?: number;
    disableAutoplay?: boolean;
    mobileImage?: string;
    tabletImage?: string;
    image?: string;
    embedSrc?: string;
    title?: string;
}

interface CmsCommonProps {
    _type?: string;
    videoCaption?: WithCaptionProps;
}

export const HTML_VIDEO_TYPE = 'Stardust - Element - Video Option - HtmlVideo';
export const YOUTUBE_VIDEO_TYPE = 'Stardust - Element - Video Option - YoutubeVideo';
export const TENCENT_VIDEO_TYPE = 'Stardust - Element - Video Option - TencentVideo';
export const EMBED_VIDEO_TYPE = 'Stardust - Element - Video Option - EmbedVideo';
export const FALLBACK_IMAGE_TYPE = 'Stardust - Element - Image';
export interface BackgroundHtmlVideoProps extends CmsCommonProps {
    content?: string[];
    contentId?: string;
    image?: string;
    title?: string;
}

export interface BackgroundYouTubeVideoProps extends CmsCommonProps {
    contentId?: string;
}

export interface BackgroundTencentVideoProps extends CmsCommonProps {
    contentId?: string;
}

export interface BackgroundEmbedVideoProps extends CmsCommonProps {
    embedSrc?: string;
}

export interface FallbackImageProps extends CmsCommonProps {
    src?: string;
    title?: string;
    alt?: string;
}

export type BackgroundVideoOptions =
    | BackgroundHtmlVideoProps
    | BackgroundYouTubeVideoProps
    | BackgroundTencentVideoProps
    | BackgroundEmbedVideoProps
    | FallbackImageProps
    | CmsCommonProps
    | undefined;

export type BackgroundVideoOptionsArray = CmsDynamicArray<BackgroundVideoOptions> | undefined;

export type LocalVideoOptions = (BackgroundHtmlVideoProps & FallbackImageProps) | undefined;

export type LocalVideoOptionsArray = CmsDynamicArray<LocalVideoOptions> | undefined;
